var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep4Psl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step_3_PSS_closed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.9681752,174.747387 L61.9681752,0 L99.1962044,0 L99.1962044,1.48954704 L64.9521752,1.489 L64.9521752,57.778 L99.1962044,57.7787456 L99.1962044,59.2682927 L64.9521752,59.268 L64.9521752,115.479 L99.1962044,115.479094 L99.1962044,116.968641 L64.9521752,116.968 L64.9521752,173.257 L99.1962044,173.25784 L99.1962044,174.747387 L61.9681752,174.747387 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 37.2280292,
    height: 174.747387,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 2.97909408 2.98452555 2.97909408 2.98452555 0 0 0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2.98452555,
    height: 2.97909408,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 71.6550523 2.98452555 71.6550523 2.98452555 68.6759582 0 68.6759582"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2.98452555,
    height: 2.97909408,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PSS_closed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "square",
    points: "8 225 8 1 240 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(130.473139, 91.000000) scale(-1, 1) translate(-130.473139, -91.000000) translate(8.540438, 1.000000)",
    stroke: "#000100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Track",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 235.905839,
    height: 4.75261324
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bed",
    transform: "translate(135.865401, 16.637631)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#E0E4E3",
    x: 105.258175,
    y: 0.25,
    width: 1,
    height: 152.21777
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#E0E4E3",
    x: 106.436277,
    y: 0.25,
    width: 1,
    height: 152.21777
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#DCD7BE",
    x: 0.25,
    y: 149.988676,
    width: 104.822336,
    height: 2.47909408
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#DCD7BE",
    x: 0.25,
    y: 0.25,
    width: 104.822336,
    height: 2.47909408
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.297477,2.91550523 C103.065063,2.91550523 103.760123,3.21471929 104.263032,3.69983218 C104.762624,4.18174442 105.072336,4.84736511 105.072336,5.58332186 L105.072336,5.58332186 L105.072336,147.134448 C105.072336,147.870405 104.762624,148.536026 104.263032,149.017938 C103.760123,149.503051 103.065063,149.802265 102.297477,149.802265 L102.297477,149.802265 L3.10514314,149.802265 C2.33738752,149.802265 1.64179113,149.502931 1.13842735,149.01766 C0.638583351,148.535782 0.328540146,147.870281 0.328540146,147.134448 L0.328540146,147.134448 L0.328540146,5.58332186 C0.328540146,4.84748902 0.638583351,4.18198838 1.13842735,3.70011047 C1.64179113,3.21483928 2.33738752,2.91550523 3.10514314,2.91550523 L3.10514314,2.91550523 Z",
    id: "Stroke-11",
    strokeWidth: 0.5,
    fill: "#C1BC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.180422,57.0393054 C101.180422,57.0393054 102.136832,84.9967183 102.081287,89.8368464 C102.024006,94.6752685 101.433845,109.192241 101.579649,112.32459 C101.725454,115.45694 101.199515,121.216641 101.472031,124.671438 C101.744547,128.124529 102.175018,134.597369 101.72719,137.90715 C101.282832,141.218637 102.850233,145.388279 98.4240185,146.986869 C93.996068,148.585459 93.0882601,146.575705 90.1305072,147.508927 C87.1727543,148.442149 82.0765322,147.447508 76.2651727,147.452627 C70.4538131,147.456039 65.5936558,147.979803 63.1358048,147.783605 C60.6762181,147.587406 56.3663,147.253016 51.148574,147.365617 C45.9325837,147.478218 39.8799521,146.654185 35.5075463,147.096057 C31.1351404,147.534518 25.1935981,147.81602 22.5899424,147.771662 C19.9880225,147.727304 14.6227559,147.850142 13.2098388,147.693183 C11.7969216,147.536224 9.30435522,147.991746 7.48873931,147.034639 C5.67659494,146.077532 4.48759217,145.217671 4.04844224,142.626147 C3.60755654,140.034623 3.89569444,136.339269 3.66830851,131.418956 C3.44265835,126.500348 2.50881383,120.607573 2.81257366,117.28585 C3.1163335,113.96242 3.62317847,110.971675 3.43745103,106.938519 C3.25345936,102.905363 3.29685363,94.9141187 3.33851212,91.6742867 C3.37843484,88.4344547 3.33677635,85.2219199 3.41141448,82.5809194 C3.48605261,79.9399189 3.2690813,57.6790826 3.2690813,57.6790826",
    id: "Fill-13",
    strokeWidth: 0.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.222775,47.2377473 L101.222775,36.5082562 C101.222775,36.5082562 100.809661,28.1655609 100.809661,26.1762801 C100.809661,24.1887055 101.108214,14.4709155 101.352958,12.7119546 C101.599437,10.9529937 101.318242,6.60933263 101.033576,6.04632865 C100.750645,5.48503074 99.2301103,5.03462755 97.5047545,4.97832715 C95.7811344,4.92373283 6.70486537,4.92202675 6.70486537,4.92202675 C6.70486537,4.92202675 4.84064788,5.60957404 4.38934756,6.83282815 C3.93804724,8.05778833 4.13939661,16.5045541 4.00747806,18.3522308 C3.87382373,20.1999075 3.63081586,25.5347968 3.73843363,27.7782824 C3.84257986,30.0200618 5.21904584,35.0990402 4.37893294,38.3798179 C3.53882003,41.6605957 4.37893294,47.6250258 4.37893294,47.6250258",
    id: "Fill-17",
    strokeWidth: 0.5,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6322505,11.2460969 C93.6322505,11.2460969 94.7535583,9.30970445 91.972854,9.85052949 C89.1886781,10.3913545 80.4004722,9.19539759 76.9827402,9.85052949 C73.5632724,10.5039553 67.6477666,10.1832137 64.0043844,10.0654946 C60.3592664,9.94606956 57.5542613,9.76693193 55.8080762,9.62874004 C54.0636269,9.48884209 52.5986366,9.15445184 52.9995996,11.2324484 C53.4005626,13.3087388 54.9315121,15.8934389 54.8429878,18.923424 C54.7544635,21.953409 54.3239925,25.6641171 54.4281387,26.9590263 C54.5322849,28.2539354 54.2840697,30.5946671 53.8310336,33.1691308 C53.3814691,35.7418884 53.3311318,36.2400616 53.1193678,37.1476923 C52.9076038,38.0553229 52.9857134,39.1472094 56.2125107,38.5927358 C59.4427796,38.0365561 63.7526977,37.3541271 65.7366833,37.8608306 C67.720669,38.3675342 72.3499688,37.9904922 74.3964422,37.9768436 C76.4429156,37.9666071 82.3827221,38.5876176 83.8251474,38.6166208 C85.2675726,38.643918 90.8064162,38.901535 91.8930085,38.9595414 C92.9796008,39.0175479 94.7414079,39.6095551 93.7207748,36.4908543 C92.698406,33.3704474 93.031674,30.1237911 93.0056374,27.938312 C92.9761293,25.7511268 92.6845199,21.2760982 93.0368813,18.2307585 C93.3892427,15.1871248 93.6322505,11.2460969 93.6322505,11.2460969",
    id: "Fill-21",
    strokeWidth: 0.5,
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2447356,11.2452439 C51.2447356,11.2452439 52.3677791,9.30885142 49.5853391,9.84967646 C46.802899,10.3905015 38.0146931,9.19454455 34.5952253,9.84967646 C31.1757575,10.5031023 25.2619875,10.1823606 21.6186053,10.0646416 C17.9734873,9.94521653 15.1684822,9.76607889 13.4222971,9.62788701 C11.676112,9.48798905 10.2128575,9.15359881 10.6138205,11.2315953 C11.0147834,13.3078858 10.6346497,16.7302675 10.5478612,19.7619587 C10.4576011,22.7919438 10.4402434,26.9206396 10.5443896,28.2172549 C10.6450643,29.512164 11.8965548,30.5938141 11.4452545,33.1682778 C10.99569,35.7410353 10.9436169,36.2375025 10.7318529,37.1468392 C10.5218246,38.0527638 10.5981985,39.1463564 13.8267316,38.5901767 C17.0570005,38.0357031 21.3651828,37.353274 23.3509042,37.8599776 C25.3348898,38.3666812 29.9624539,37.9896391 32.0089273,37.9759905 C34.0554007,37.9657541 39.996943,38.5867646 41.4393683,38.6157678 C42.8817935,38.643065 48.4206371,38.9006819 49.5072294,38.9586884 C50.5938217,39.0166949 52.3556287,39.6087021 51.3349957,36.4882952 C50.3126269,33.3695943 50.6458948,30.122938 50.6181225,27.9374589 C50.5903502,25.7502738 50.2987407,21.2752451 50.6511021,18.2299054 C51.0034636,15.1845657 51.2447356,11.2452439 51.2447356,11.2452439",
    id: "Fill-25",
    strokeWidth: 0.5,
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.249853,63.8786095 C101.249853,63.8786095 102.910985,65.3304774 103.412623,63.2371262 C103.915996,61.1420689 104.002785,55.6314542 104.058329,52.7498975 C104.11561,49.8700468 103.959391,47.6555645 103.964598,43.677003 C103.971541,39.6984415 103.704232,35.7062315 103.730269,34.6604089 C103.75457,33.6128803 103.752834,32.0825331 101.905974,31.6901364 C100.057379,31.2960336 98.2487057,31.2312028 96.4296182,31.5058805 C94.6105308,31.7805582 91.9183508,31.3540401 89.6427557,31.4120465 C87.3654248,31.4683469 83.4043966,31.5707113 81.9671787,31.6560149 C80.528225,31.7413186 79.1864744,31.563887 76.1714411,31.1714903 C73.1529362,30.7790936 71.6705882,31.2806789 68.7614369,30.8268636 C65.8522856,30.3730483 59.9003287,29.9021722 56.2187595,30.4924734 C52.5371903,31.0827745 48.2758738,32.4237476 40.8623982,31.6713696 C33.4489225,30.9189915 28.8907892,32.5346424 25.4157767,30.999177 C21.9372927,29.4637115 18.9812756,30.1819681 15.5079989,30.4003454 C12.0329864,30.6204288 10.8057967,30.7722693 8.70204287,31.1015413 C6.60002483,31.4291073 2.44979764,31.2840911 2.44979764,31.2840911 C2.44979764,31.2840911 1.03688047,32.2070764 1.3822988,33.4951613 C1.72771712,34.7849522 1.47776617,43.5558718 1.37709148,48.5222494 C1.2764168,53.4869209 1.23475831,62.317553 1.27815257,62.5615214 C1.32501837,62.8037837 0.550864741,65.0950393 5.23918078,64.2266483 C9.93096836,63.3582573 13.5674075,62.4250356 18.5560118,62.6382947 C22.8433649,62.8225505 30.2967633,64.7470005 33.2927031,63.8769034 C36.288643,63.0068064 46.1356688,64.4228467 50.7354606,63.5766346 C54.7450904,62.8379052 66.2636632,63.0614007 69.7161107,62.9078542 C73.1685582,62.7560137 75.8815674,63.2217715 80.2019001,62.6400007 C82.524361,62.3277894 88.9119963,63.2439505 91.7603957,63.5715164 C94.6122666,63.8973763 101.249853,63.8786095 101.249853,63.8786095",
    id: "Fill-29",
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.6271777,
    x: 0.31358885,
    y: 0.31358885,
    width: 107.051362,
    height: 152.090592
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main",
    transform: "translate(127.390365, 5.252613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.161448,0.31358885 L116.161448,174.433798 L62.4388443,174.433798 L62.4388443,0.31358885 L116.161448,0.31358885 Z",
    id: "Fill-33",
    strokeWidth: 0.6271777,
    fill: "#E4E0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2829075,0.31358885 L62.2829075,174.433798 L0.31358885,174.433798 L0.31358885,0.31358885 L62.2829075,0.31358885 Z",
    id: "Fill-36",
    strokeWidth: 0.6271777,
    fill: "#D3CCB1"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    mask: "url(#mask-2)",
    strokeDasharray: "3.763066202090592,0.940766550522648",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(124.405839, 56.837979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3310219,0.25 L65.3310219,71.4050523 L0.25,71.4050523 L0.25,0.25 L65.3310219,0.25 Z",
    id: "Fill-63",
    strokeWidth: 0.5,
    fill: "#DCD7BE"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Stroke-65",
    mask: "url(#mask-4)",
    strokeDasharray: "3.763066202090592,0.940766550522648",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.83826634,
    y1: 68.8327526,
    x2: 2.83826634,
    y2: 2.82229965,
    id: "Path",
    strokeWidth: 0.5,
    strokeDasharray: "3.763066202090592,0.940766550522648"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Stroke-65",
    mask: "url(#mask-6)",
    strokeDasharray: "3.763066202090592,0.940766550522648",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shelf",
    transform: "translate(167.288759, 29.947735)",
    fill: "#EBDFB9",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4481022,0.25 L22.4481022,125.18554 L0.25,125.18554 L0.25,0.25 L22.4481022,0.25 Z",
    id: "Fill-68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    points: "8.7179562 108.188153 14.0586861 108.188153 14.0586861 17.2473868 8.7179562 17.2473868"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.852814, 137.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-45.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-7)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(135.852814, 30.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-90.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-7)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Psl);
export default __webpack_public_path__ + "static/media/step_4_PSL.97421d522a7de61833344b0f6bdfaffa.svg";
export { ForwardRef as ReactComponent };